module.exports = __webpack_public_path__ + "img/NL9297060.b02fac0e.png";